// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2715%27 height=%2715%27 fill=%27%2348D1CC%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.CreateNewAccount {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.createNewAccountContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: clamp(300px, 31.5vw, 460px) !important;
  gap: 12px;
  box-sizing: border-box;
}

.getStartedText {
  font-family: "Inter", sans-serif;
  font-size: 30px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  margin: 0;
}

.signInText2 {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  color: #9ca3af;
  text-align: center;
  margin: 0 0 16px 0;
}

.generalInputContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
}

.labelText {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
}

.phoneNumberInputContainer {
  width: 100%;
  position: relative;
  box-sizing: border-box;
}

.phoneInput {
  scrollbar-width: thin;
  scrollbar-color: #3d3d3d #1a1a1a;
}

/* Main container styling */
.containerClass {
  background-color: transparent !important;
  border-radius: 12px !important;
  width: 100% !important;
  position: relative !important;
  box-sizing: border-box !important;
}

/* Phone Input Field */
.react-tel-input {
  width: 100% !important;
  position: relative !important;
  font-family: "Inter", sans-serif !important;
}

.react-tel-input .form-control {
  height: 54px !important;
  font-size: 16px !important;
  padding: 0 16px 0 70px !important;
  background: #1c1c22 !important;
  color: #ffffff !important;
  border: 1.5px solid rgba(255, 255, 255, 0.14) !important;
  border-radius: 12px !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25) !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

.react-tel-input .form-control:focus {
  border-color: #48D1CC !important;
  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.2), 0 4px 16px rgba(0, 0, 0, 0.35) !important;
  outline: none !important;
  background: #1e1e26 !important;
}

.react-tel-input .form-control::placeholder {
  color: #6b7280 !important;
  font-weight: 400 !important;
}

/* Flag Dropdown wrapper: static so .country-list positions relative to .react-tel-input (full width) */
.react-tel-input .flag-dropdown {
  position: static !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
}

.react-tel-input .flag-dropdown.open {
  background: transparent !important;
  border: none !important;
}

/* Selected Flag Button on left side of input */
.react-tel-input .selected-flag {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  height: 54px !important;
  width: 58px !important;
  min-width: 58px !important;
  max-width: 58px !important;
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  border-right: 1.5px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 12px 0 0 12px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  cursor: pointer !important;
  z-index: 3 !important;
  box-sizing: border-box !important;
  transition: background-color 0.2s ease !important;
}

.react-tel-input .selected-flag:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}

/* Keep exact sprite sheet dimensions (16px x 11px) to prevent sliced adjacent flags */
.react-tel-input .flag {
  width: 16px !important;
  height: 11px !important;
  border-radius: 2px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) !important;
  flex-shrink: 0 !important;
  display: inline-block !important;
  transform: scale(1.15) !important;
  transform-origin: center !important;
}

.react-tel-input .selected-flag .flag {
  position: relative !important;
  top: auto !important;
  margin: 0 0 0 13px !important;
}

/* Arrow inside selected-flag (child of .flag in react-phone-input-2) */
.react-tel-input .selected-flag .arrow {
  position: absolute !important;
  top: 50% !important;
  left: 22px !important;
  margin: 0 !important;
  transform: translateY(-50%) !important;
  width: 0 !important;
  height: 0 !important;
  border-left: 3.5px solid transparent !important;
  border-right: 3.5px solid transparent !important;
  border-top: 4.5px solid #48D1CC !important;
  border-bottom: none !important;
  transition: transform 0.2s ease !important;
}

.react-tel-input .selected-flag.open .arrow,
.react-tel-input .selected-flag .arrow.up {
  border-top: none !important;
  border-bottom: 4.5px solid #48D1CC !important;
  transform: translateY(-50%) !important;
}

/* Country Dropdown List: full width matching phone input and Next button */
.react-tel-input .country-list {
  position: absolute !important;
  top: calc(100% + 6px) !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  background: #18181d !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 14px !important;
  max-height: 290px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  z-index: 9999 !important;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(72, 209, 204, 0.15) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  animation: dropdownFadeIn 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Sticky search header */
.react-tel-input .country-list .search {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
  background: #1f1f26 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
  padding: 10px 12px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  box-sizing: border-box !important;
}

/* Hide raw emoji */
.react-tel-input .country-list .search-emoji {
  display: none !important;
}

/* Sleek search input with integrated SVG search icon */
.react-tel-input .search-box {
  width: 100% !important;
  margin: 0 !important;
  height: 38px !important;
  padding: 8px 12px 8px 36px !important;
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #ffffff !important;
  background: #141418 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 12px center !important;
  border: 1px solid rgba(255, 255, 255, 0.16) !important;
  border-radius: 8px !important;
  outline: none !important;
  transition: all 0.2s ease !important;
  box-sizing: border-box !important;
}

.react-tel-input .search-box:focus {
  border-color: rgba(72, 209, 204, 0.7) !important;
  box-shadow: 0 0 0 2.5px rgba(72, 209, 204, 0.18) !important;
  background-color: #16161c !important;
}

.react-tel-input .search-box::placeholder {
  color: #9ca3af !important;
  font-size: 13.5px !important;
  font-weight: 400 !important;
}

/* Country Option Item */
.react-tel-input .country-list .country {
  background: transparent !important;
  color: #ffffff !important;
  padding: 9px 14px !important;
  font-size: 14px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;
  transition: background 0.15s ease !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 10px !important;
  cursor: pointer !important;
  min-height: 42px !important;
  box-sizing: border-box !important;
}

.react-tel-input .country-list .country:hover {
  background: rgba(72, 209, 204, 0.12) !important;
}

.react-tel-input .country-list .country.highlight {
  background: rgba(72, 209, 204, 0.18) !important;
  border-left: 3px solid #48D1CC !important;
}

/* Country Name */
.react-tel-input .country-list .country .country-name {
  color: #f3f4f6 !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  flex: 1 1 !important;
  text-align: left !important;
  margin-right: 8px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* Dial Code Badge */
.react-tel-input .country-list .country .dial-code {
  color: #48D1CC !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  background: rgba(72, 209, 204, 0.12) !important;
  padding: 3px 8px !important;
  border-radius: 6px !important;
  flex-shrink: 0 !important;
  display: inline-block !important;
}

/* Country Flag in Dropdown */
.react-tel-input .country-list .country .flag {
  margin-right: 10px !important;
}

/* Custom Scrollbar - Eliminate ugly arrow buttons completely */
.react-tel-input .country-list::-webkit-scrollbar-button,
.react-tel-input .country-list::-webkit-scrollbar-button:single-button,
.react-tel-input .country-list::-webkit-scrollbar-button:vertical:decrement,
.react-tel-input .country-list::-webkit-scrollbar-button:vertical:increment,
.react-tel-input .country-list::-webkit-scrollbar-button:start:decrement,
.react-tel-input .country-list::-webkit-scrollbar-button:end:increment {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
  -webkit-appearance: none !important;
}

.react-tel-input .country-list {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(72, 209, 204, 0.3) transparent !important;
}

.react-tel-input .country-list::-webkit-scrollbar {
  width: 5px !important;
}

.react-tel-input .country-list::-webkit-scrollbar-track {
  background: transparent !important;
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.react-tel-input .country-list::-webkit-scrollbar-thumb {
  background: rgba(72, 209, 204, 0.35) !important;
  border-radius: 4px !important;
}

.react-tel-input .country-list::-webkit-scrollbar-thumb:hover {
  background: #48D1CC !important;
}

/* Error Tooltip */
.errorTooltip {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #ff4444 0%, #ff6666 100%);
  color: white;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  margin-top: 8px;
  text-align: center;
  z-index: 1001;
  box-shadow: 0 6px 20px rgba(255, 68, 68, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  animation: errorSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes errorSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Checkbox Container Styling */
.checkboxContainer {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  margin: 16px 0;
  padding: 0;
  box-sizing: border-box;
}

.checkboxContainer input[type="checkbox"] {
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  accent-color: #48D1CC;
  border: 2px solid #333;
  border-radius: 4px;
  background: linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.checkboxContainer input[type="checkbox"]:hover {
  border-color: #48D1CC;
  box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.2);
}

.checkboxContainer input[type="checkbox"]:checked {
  background: #48D1CC;
  border-color: #48D1CC;
  box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.3);
}

.checkboxContainer input[type="checkbox"]:focus {
  outline: none;
  border-color: #48D1CC;
  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.3);
}

.checkboxLabel {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #b0b0b0;
  line-height: 1.5;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  flex: 1 1;
  margin: 0;
  padding: 0;
  transition: color 0.3s ease;
}

.checkboxLabel:hover {
  color: #ffffff;
}

.checkboxContainer:hover .checkboxLabel {
  color: #ffffff;
}

/* Button Styling */
.btnContainer {
  width: 100% !important;
  height: 56px !important;
  background-color: #48D1CC !important;
  border: none !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: white !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-top: 10px !important;
  box-sizing: border-box !important;
}

/* 
.btnContainer:hover {
  background-color: #3bb5a8 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.3);
} */
.btnContainerDuplicate {
  background-color: #3a3a4a !important;
}

.btnContainer:active {
  transform: translateY(0);
}

.btnText {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: white !important;
}

/* Tablet Responsive Styles */
@media (max-width: 1024px) and (min-width: 769px) {
  .checkboxContainer {
    margin: 15px 0;
    gap: 11px;
  }

  .checkboxContainer input[type="checkbox"] {
    width: 19px;
    height: 19px;
    min-width: 19px;
    min-height: 19px;
  }

  .checkboxLabel {
    font-size: 13.5px;
    line-height: 1.45;
  }
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .CreateNewAccount {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .createNewAccountContainer {
    width: 100% !important;
    max-width: 400px;
    gap: 20px;
    padding: 20px 0;
  }

  .getStartedText {
    font-size: 24px !important;
    font-weight: 700 !important;
    text-align: center;
    margin-bottom: 8px;
    color: white;
  }

  .signInText2 {
    font-size: 16px !important;
    text-align: center;
    color: #b0b0b0;
    margin-bottom: 10px;
  }

  .generalInputContainer {
    width: 100%;
    gap: 12px;
  }

  .labelText {
    font-size: 16px !important;
    font-weight: 500;
    color: white;
    margin-bottom: 4px;
  }

  .phoneNumberInputContainer {
    width: 100%;
    position: relative;
  }

  /* Mobile Phone Input */
  .react-tel-input .form-control {
    height: 56px !important;
    font-size: 16px !important;
    padding: 16px 18px 16px 88px !important;
    border-radius: 14px !important;
  }

  /* Mobile Country Selection */
  .react-tel-input .selected-flag {
    width: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
    height: 56px !important;
    padding: 0 10px !important;
    border-radius: 14px 0 0 14px !important;
  }

  .react-tel-input .selected-flag .selected-dial-code {
    font-size: 13px !important;
  }

  .react-tel-input .selected-flag .flag {
    width: 18px !important;
    height: 14px !important;
  }

  /* Mobile Dropdown */
  .react-tel-input .country-list {
    max-height: 35vh !important;
    margin-top: 6px !important;
    border-radius: 14px !important;
  }

  .react-tel-input .country-list .country {
    padding: 14px 16px !important;
    font-size: 14px !important;
    min-height: 52px !important;
  }

  .react-tel-input .country-list .country .country-name {
    font-size: 14px !important;
  }

  .react-tel-input .country-list .country .dial-code {
    font-size: 12px !important;
    min-width: 40px !important;
    padding: 3px 6px !important;
  }

  .react-tel-input .country-list .country .flag {
    width: 18px !important;
    height: 14px !important;
  }

  /* Mobile Search Box */
  .react-tel-input .search-box {
    margin: 12px !important;
    width: calc(100% - 24px) !important;
    font-size: 14px !important;
    padding: 10px 14px !important;
    height: 40px !important;
    border-radius: 10px !important;
  }

  /* Mobile Checkbox Container */
  .checkboxContainer {
    margin: 14px 0;
    gap: 10px;
  }

  .checkboxContainer input[type="checkbox"] {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
  }

  .checkboxLabel {
    font-size: 13px;
    line-height: 1.4;
  }

  /* Mobile Button */
  .btnContainer {
    height: 52px !important;
    font-size: 15px !important;
  }

  .btnText {
    font-size: 15px !important;
  }
}

/* Extra Small Mobile Devices */
@media (max-width: 480px) {
  .CreateNewAccount {
    padding: 0 15px;
  }

  .createNewAccountContainer {
    gap: 16px;
    padding: 15px 0;
  }

  .getStartedText {
    font-size: 22px !important;
  }

  .signInText2 {
    font-size: 14px !important;
  }

  .labelText {
    font-size: 15px !important;
  }

  /* Extra Small Phone Input */
  .react-tel-input .form-control {
    height: 52px !important;
    font-size: 15px !important;
    padding: 14px 16px 14px 84px !important;
    border-radius: 12px !important;
  }

  /* Extra Small Country Selection */
  .react-tel-input .selected-flag {
    width: 76px !important;
    min-width: 76px !important;
    max-width: 76px !important;
    height: 52px !important;
    padding: 0 8px !important;
    border-radius: 12px 0 0 12px !important;
  }

  .react-tel-input .selected-flag .selected-dial-code {
    font-size: 12px !important;
  }

  .react-tel-input .selected-flag .flag {
    width: 16px !important;
    height: 12px !important;
  }

  /* Extra Small Dropdown */
  .react-tel-input .country-list {
    max-height: 30vh !important;
    margin-top: 4px !important;
    border-radius: 12px !important;
  }

  .react-tel-input .country-list .country {
    padding: 12px 14px !important;
    font-size: 13px !important;
    min-height: 48px !important;
  }

  .react-tel-input .country-list .country .country-name {
    font-size: 13px !important;
  }

  .react-tel-input .country-list .country .dial-code {
    font-size: 11px !important;
    min-width: 36px !important;
    padding: 2px 5px !important;
  }

  .react-tel-input .country-list .country .flag {
    width: 16px !important;
    height: 12px !important;
  }

  /* Extra Small Search Box */
  .react-tel-input .search-box {
    margin: 10px !important;
    width: calc(100% - 20px) !important;
    font-size: 13px !important;
    padding: 8px 12px !important;
    height: 36px !important;
    border-radius: 8px !important;
  }

  /* Extra Small Checkbox Container */
  .checkboxContainer {
    margin: 12px 0;
    gap: 8px;
  }

  .checkboxContainer input[type="checkbox"] {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
  }

  .checkboxLabel {
    font-size: 12px;
    line-height: 1.3;
  }

  /* Extra Small Button */
  .btnContainer {
    height: 48px !important;
    font-size: 14px !important;
  }

  .btnText {
    font-size: 14px !important;
  }
}

/* Very Small Screens (360px and below) */
@media (max-width: 360px) {
  .CreateNewAccount {
    padding: 0 12px;
  }

  .createNewAccountContainer {
    gap: 14px;
    padding: 12px 0;
  }

  /* Very Small Phone Input */
  .react-tel-input .form-control {
    height: 48px !important;
    font-size: 14px !important;
    padding: 12px 14px 12px 80px !important;
    border-radius: 10px !important;
  }

  /* Very Small Country Selection */
  .react-tel-input .selected-flag {
    width: 72px !important;
    min-width: 72px !important;
    max-width: 72px !important;
    height: 48px !important;
    padding: 0 6px !important;
    border-radius: 10px 0 0 10px !important;
  }

  .react-tel-input .selected-flag .selected-dial-code {
    font-size: 11px !important;
  }

  .react-tel-input .selected-flag .flag {
    width: 14px !important;
    height: 10px !important;
  }

  /* Very Small Dropdown */
  .react-tel-input .country-list {
    max-height: 25vh !important;
    border-radius: 10px !important;
  }

  .react-tel-input .country-list .country {
    padding: 10px 12px !important;
    font-size: 12px !important;
    min-height: 44px !important;
  }

  .react-tel-input .country-list .country .country-name {
    font-size: 12px !important;
  }

  .react-tel-input .country-list .country .dial-code {
    font-size: 10px !important;
    min-width: 32px !important;
    padding: 2px 4px !important;
  }

  .react-tel-input .country-list .country .flag {
    width: 14px !important;
    height: 10px !important;
  }

  /* Very Small Search Box */
  .react-tel-input .search-box {
    margin: 8px !important;
    width: calc(100% - 16px) !important;
    font-size: 12px !important;
    padding: 6px 10px !important;
    height: 32px !important;
    border-radius: 6px !important;
  }

  /* Very Small Checkbox Container */
  .checkboxContainer {
    margin: 10px 0;
    gap: 6px;
  }

  .checkboxContainer input[type="checkbox"] {
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
  }

  .checkboxLabel {
    font-size: 11px;
    line-height: 1.2;
  }

  /* Very Small Button */
  .btnContainer {
    height: 44px !important;
    font-size: 13px !important;
  }

  .btnText {
    font-size: 13px !important;
  }
}

/* Snackbar Styles */
.snackbar {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  z-index: 1000;
  animation: slideUp 0.3s ease-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 250px;
  text-align: center;
}

.snackbar-success {
  background-color: #4caf50;
}

.snackbar-error {
  background-color: #f44336;
}

.snackbar-info {
  background-color: #48d1cc;
}

.snackbar-message {
  display: block;
  line-height: 1.4;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Responsive adjustments for snackbar */
@media (max-width: 1024px) {
  .snackbar {
    font-size: 13px;
    padding: 10px 20px;
    min-width: 220px;
  }
}

@media (max-width: 768px) {
  .snackbar {
    font-size: 12px;
    padding: 8px 16px;
    min-width: 200px;
    bottom: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/EnterMobileNumber/EnterMobileNumber.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;EAC7C,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,wDAAwD;EACxD,8BAA8B;EAC9B,2CAA2C;EAC3C,2BAA2B;EAC3B,4DAA4D;EAC5D,oDAAoD;EACpD,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,wFAAwF;EACxF,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,uGAAuG;AACvG;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;EACvB,8DAA8D;EAC9D,uCAAuC;EACvC,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,sFAAsF;AACtF;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,mDAAmD;EACnD,yBAAyB;EACzB,gCAAgC;EAChC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,uEAAuE;AACvE;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;EAC/C,gDAAgD;EAChD,0CAA0C;EAC1C,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA,2EAA2E;AAC3E;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,sDAAsD;EACtD,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,yFAAyF;EACzF,sCAAsC;EACtC,8CAA8C;EAC9C,sEAAsE;AACxE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,6DAA6D;EAC7D,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4FAAoZ;EACpZ,sDAAsD;EACtD,6BAA6B;EAC7B,wBAAwB;EACxB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;EAChD,2DAA2D;EAC3D,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,6DAA6D;EAC7D,4CAA4C;EAC5C,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;EAChC,+CAA+C;EAC/C,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;AAC/B;;AAEA,+DAA+D;AAC/D;;;;;;EAME,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,+DAA+D;AACjE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,6CAA6C;EAC7C,0CAA0C;EAC1C,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,cAAc;EACd,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,6DAA6D;EAC7D,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,SAAO;EACP,SAAS;EACT,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;;;;GAKG;AACH;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,uBAAuB;EACvB;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,uCAAuC;IACvC,8BAA8B;EAChC;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,uCAAuC;EACzC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,sBAAsB;EACtB;IACE,uBAAuB;IACvB,mCAAmC;IACnC,0BAA0B;IAC1B,6BAA6B;IAC7B,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,4BAA4B;EAC5B;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,uCAAuC;IACvC,8BAA8B;EAChC;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,uCAAuC;EACzC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,yBAAyB;EACzB;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,2BAA2B;EAC3B;IACE,uBAAuB;IACvB,mCAAmC;IACnC,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA,mCAAmC;EACnC;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,uBAAuB;EACvB;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,uCAAuC;IACvC,8BAA8B;EAChC;;EAEA,iCAAiC;EACjC;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,uCAAuC;EACzC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,wBAAwB;EACxB;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,mCAAmC;IACnC,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA,kCAAkC;EAClC;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["/* Base Styles */\n.CreateNewAccount {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.createNewAccountContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: clamp(300px, 31.5vw, 460px) !important;\n  gap: 12px;\n  box-sizing: border-box;\n}\n\n.getStartedText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 30px;\n  font-weight: 700;\n  color: #ffffff;\n  text-align: center;\n  margin: 0;\n}\n\n.signInText2 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  color: #9ca3af;\n  text-align: center;\n  margin: 0 0 16px 0;\n}\n\n.generalInputContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-sizing: border-box;\n}\n\n.labelText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n.phoneNumberInputContainer {\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.phoneInput {\n  scrollbar-width: thin;\n  scrollbar-color: #3d3d3d #1a1a1a;\n}\n\n/* Main container styling */\n.containerClass {\n  background-color: transparent !important;\n  border-radius: 12px !important;\n  width: 100% !important;\n  position: relative !important;\n  box-sizing: border-box !important;\n}\n\n/* Phone Input Field */\n.react-tel-input {\n  width: 100% !important;\n  position: relative !important;\n  font-family: \"Inter\", sans-serif !important;\n}\n\n.react-tel-input .form-control {\n  height: 54px !important;\n  font-size: 16px !important;\n  padding: 0 16px 0 70px !important;\n  background: #1c1c22 !important;\n  color: #ffffff !important;\n  border: 1.5px solid rgba(255, 255, 255, 0.14) !important;\n  border-radius: 12px !important;\n  font-family: \"Inter\", sans-serif !important;\n  font-weight: 500 !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25) !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n.react-tel-input .form-control:focus {\n  border-color: #48D1CC !important;\n  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.2), 0 4px 16px rgba(0, 0, 0, 0.35) !important;\n  outline: none !important;\n  background: #1e1e26 !important;\n}\n\n.react-tel-input .form-control::placeholder {\n  color: #6b7280 !important;\n  font-weight: 400 !important;\n}\n\n/* Flag Dropdown wrapper: static so .country-list positions relative to .react-tel-input (full width) */\n.react-tel-input .flag-dropdown {\n  position: static !important;\n  background: transparent !important;\n  border: none !important;\n  padding: 0 !important;\n}\n\n.react-tel-input .flag-dropdown.open {\n  background: transparent !important;\n  border: none !important;\n}\n\n/* Selected Flag Button on left side of input */\n.react-tel-input .selected-flag {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  height: 54px !important;\n  width: 58px !important;\n  min-width: 58px !important;\n  max-width: 58px !important;\n  padding: 0 !important;\n  background: transparent !important;\n  border: none !important;\n  border-right: 1.5px solid rgba(255, 255, 255, 0.12) !important;\n  border-radius: 12px 0 0 12px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  cursor: pointer !important;\n  z-index: 3 !important;\n  box-sizing: border-box !important;\n  transition: background-color 0.2s ease !important;\n}\n\n.react-tel-input .selected-flag:hover {\n  background: rgba(255, 255, 255, 0.06) !important;\n}\n\n/* Keep exact sprite sheet dimensions (16px x 11px) to prevent sliced adjacent flags */\n.react-tel-input .flag {\n  width: 16px !important;\n  height: 11px !important;\n  border-radius: 2px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) !important;\n  flex-shrink: 0 !important;\n  display: inline-block !important;\n  transform: scale(1.15) !important;\n  transform-origin: center !important;\n}\n\n.react-tel-input .selected-flag .flag {\n  position: relative !important;\n  top: auto !important;\n  margin: 0 0 0 13px !important;\n}\n\n/* Arrow inside selected-flag (child of .flag in react-phone-input-2) */\n.react-tel-input .selected-flag .arrow {\n  position: absolute !important;\n  top: 50% !important;\n  left: 22px !important;\n  margin: 0 !important;\n  transform: translateY(-50%) !important;\n  width: 0 !important;\n  height: 0 !important;\n  border-left: 3.5px solid transparent !important;\n  border-right: 3.5px solid transparent !important;\n  border-top: 4.5px solid #48D1CC !important;\n  border-bottom: none !important;\n  transition: transform 0.2s ease !important;\n}\n\n.react-tel-input .selected-flag.open .arrow,\n.react-tel-input .selected-flag .arrow.up {\n  border-top: none !important;\n  border-bottom: 4.5px solid #48D1CC !important;\n  transform: translateY(-50%) !important;\n}\n\n/* Country Dropdown List: full width matching phone input and Next button */\n.react-tel-input .country-list {\n  position: absolute !important;\n  top: calc(100% + 6px) !important;\n  left: 0 !important;\n  right: 0 !important;\n  width: 100% !important;\n  min-width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n  background: #18181d !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  border-radius: 14px !important;\n  max-height: 290px !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  z-index: 9999 !important;\n  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(72, 209, 204, 0.15) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  animation: dropdownFadeIn 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Sticky search header */\n.react-tel-input .country-list .search {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 10 !important;\n  background: #1f1f26 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;\n  padding: 10px 12px !important;\n  margin: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  box-sizing: border-box !important;\n}\n\n/* Hide raw emoji */\n.react-tel-input .country-list .search-emoji {\n  display: none !important;\n}\n\n/* Sleek search input with integrated SVG search icon */\n.react-tel-input .search-box {\n  width: 100% !important;\n  margin: 0 !important;\n  height: 38px !important;\n  padding: 8px 12px 8px 36px !important;\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  color: #ffffff !important;\n  background: #141418 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' fill='%2348D1CC' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E\") no-repeat 12px center !important;\n  border: 1px solid rgba(255, 255, 255, 0.16) !important;\n  border-radius: 8px !important;\n  outline: none !important;\n  transition: all 0.2s ease !important;\n  box-sizing: border-box !important;\n}\n\n.react-tel-input .search-box:focus {\n  border-color: rgba(72, 209, 204, 0.7) !important;\n  box-shadow: 0 0 0 2.5px rgba(72, 209, 204, 0.18) !important;\n  background-color: #16161c !important;\n}\n\n.react-tel-input .search-box::placeholder {\n  color: #9ca3af !important;\n  font-size: 13.5px !important;\n  font-weight: 400 !important;\n}\n\n/* Country Option Item */\n.react-tel-input .country-list .country {\n  background: transparent !important;\n  color: #ffffff !important;\n  padding: 9px 14px !important;\n  font-size: 14px !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;\n  transition: background 0.15s ease !important;\n  position: relative !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 10px !important;\n  cursor: pointer !important;\n  min-height: 42px !important;\n  box-sizing: border-box !important;\n}\n\n.react-tel-input .country-list .country:hover {\n  background: rgba(72, 209, 204, 0.12) !important;\n}\n\n.react-tel-input .country-list .country.highlight {\n  background: rgba(72, 209, 204, 0.18) !important;\n  border-left: 3px solid #48D1CC !important;\n}\n\n/* Country Name */\n.react-tel-input .country-list .country .country-name {\n  color: #f3f4f6 !important;\n  font-family: \"Inter\", sans-serif !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  flex: 1 !important;\n  text-align: left !important;\n  margin-right: 8px !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n/* Dial Code Badge */\n.react-tel-input .country-list .country .dial-code {\n  color: #48D1CC !important;\n  font-family: \"Inter\", sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  letter-spacing: 0.3px !important;\n  background: rgba(72, 209, 204, 0.12) !important;\n  padding: 3px 8px !important;\n  border-radius: 6px !important;\n  flex-shrink: 0 !important;\n  display: inline-block !important;\n}\n\n/* Country Flag in Dropdown */\n.react-tel-input .country-list .country .flag {\n  margin-right: 10px !important;\n}\n\n/* Custom Scrollbar - Eliminate ugly arrow buttons completely */\n.react-tel-input .country-list::-webkit-scrollbar-button,\n.react-tel-input .country-list::-webkit-scrollbar-button:single-button,\n.react-tel-input .country-list::-webkit-scrollbar-button:vertical:decrement,\n.react-tel-input .country-list::-webkit-scrollbar-button:vertical:increment,\n.react-tel-input .country-list::-webkit-scrollbar-button:start:decrement,\n.react-tel-input .country-list::-webkit-scrollbar-button:end:increment {\n  display: none !important;\n  width: 0 !important;\n  height: 0 !important;\n  background: transparent !important;\n  -webkit-appearance: none !important;\n}\n\n.react-tel-input .country-list {\n  scrollbar-width: thin !important;\n  scrollbar-color: rgba(72, 209, 204, 0.3) transparent !important;\n}\n\n.react-tel-input .country-list::-webkit-scrollbar {\n  width: 5px !important;\n}\n\n.react-tel-input .country-list::-webkit-scrollbar-track {\n  background: transparent !important;\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n}\n\n.react-tel-input .country-list::-webkit-scrollbar-thumb {\n  background: rgba(72, 209, 204, 0.35) !important;\n  border-radius: 4px !important;\n}\n\n.react-tel-input .country-list::-webkit-scrollbar-thumb:hover {\n  background: #48D1CC !important;\n}\n\n/* Error Tooltip */\n.errorTooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: linear-gradient(135deg, #ff4444 0%, #ff6666 100%);\n  color: white;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  margin-top: 8px;\n  text-align: center;\n  z-index: 1001;\n  box-shadow: 0 6px 20px rgba(255, 68, 68, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  animation: errorSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes errorSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Checkbox Container Styling */\n.checkboxContainer {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  margin: 16px 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.checkboxContainer input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  min-height: 20px;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  accent-color: #48D1CC;\n  border: 2px solid #333;\n  border-radius: 4px;\n  background: linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 100%);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-shrink: 0;\n}\n\n.checkboxContainer input[type=\"checkbox\"]:hover {\n  border-color: #48D1CC;\n  box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.2);\n}\n\n.checkboxContainer input[type=\"checkbox\"]:checked {\n  background: #48D1CC;\n  border-color: #48D1CC;\n  box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.3);\n}\n\n.checkboxContainer input[type=\"checkbox\"]:focus {\n  outline: none;\n  border-color: #48D1CC;\n  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.3);\n}\n\n.checkboxLabel {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #b0b0b0;\n  line-height: 1.5;\n  cursor: pointer;\n  user-select: none;\n  flex: 1;\n  margin: 0;\n  padding: 0;\n  transition: color 0.3s ease;\n}\n\n.checkboxLabel:hover {\n  color: #ffffff;\n}\n\n.checkboxContainer:hover .checkboxLabel {\n  color: #ffffff;\n}\n\n/* Button Styling */\n.btnContainer {\n  width: 100% !important;\n  height: 56px !important;\n  background-color: #48D1CC !important;\n  border: none !important;\n  border-radius: 12px !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  color: white !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin-top: 10px !important;\n  box-sizing: border-box !important;\n}\n\n/* \n.btnContainer:hover {\n  background-color: #3bb5a8 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.3);\n} */\n.btnContainerDuplicate {\n  background-color: #3a3a4a !important;\n}\n\n.btnContainer:active {\n  transform: translateY(0);\n}\n\n.btnText {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  color: white !important;\n}\n\n/* Tablet Responsive Styles */\n@media (max-width: 1024px) and (min-width: 769px) {\n  .checkboxContainer {\n    margin: 15px 0;\n    gap: 11px;\n  }\n\n  .checkboxContainer input[type=\"checkbox\"] {\n    width: 19px;\n    height: 19px;\n    min-width: 19px;\n    min-height: 19px;\n  }\n\n  .checkboxLabel {\n    font-size: 13.5px;\n    line-height: 1.45;\n  }\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 768px) {\n  .CreateNewAccount {\n    width: 100%;\n    padding: 0 20px;\n    box-sizing: border-box;\n  }\n\n  .createNewAccountContainer {\n    width: 100% !important;\n    max-width: 400px;\n    gap: 20px;\n    padding: 20px 0;\n  }\n\n  .getStartedText {\n    font-size: 24px !important;\n    font-weight: 700 !important;\n    text-align: center;\n    margin-bottom: 8px;\n    color: white;\n  }\n\n  .signInText2 {\n    font-size: 16px !important;\n    text-align: center;\n    color: #b0b0b0;\n    margin-bottom: 10px;\n  }\n\n  .generalInputContainer {\n    width: 100%;\n    gap: 12px;\n  }\n\n  .labelText {\n    font-size: 16px !important;\n    font-weight: 500;\n    color: white;\n    margin-bottom: 4px;\n  }\n\n  .phoneNumberInputContainer {\n    width: 100%;\n    position: relative;\n  }\n\n  /* Mobile Phone Input */\n  .react-tel-input .form-control {\n    height: 56px !important;\n    font-size: 16px !important;\n    padding: 16px 18px 16px 88px !important;\n    border-radius: 14px !important;\n  }\n\n  /* Mobile Country Selection */\n  .react-tel-input .selected-flag {\n    width: 80px !important;\n    min-width: 80px !important;\n    max-width: 80px !important;\n    height: 56px !important;\n    padding: 0 10px !important;\n    border-radius: 14px 0 0 14px !important;\n  }\n\n  .react-tel-input .selected-flag .selected-dial-code {\n    font-size: 13px !important;\n  }\n\n  .react-tel-input .selected-flag .flag {\n    width: 18px !important;\n    height: 14px !important;\n  }\n\n  /* Mobile Dropdown */\n  .react-tel-input .country-list {\n    max-height: 35vh !important;\n    margin-top: 6px !important;\n    border-radius: 14px !important;\n  }\n\n  .react-tel-input .country-list .country {\n    padding: 14px 16px !important;\n    font-size: 14px !important;\n    min-height: 52px !important;\n  }\n\n  .react-tel-input .country-list .country .country-name {\n    font-size: 14px !important;\n  }\n\n  .react-tel-input .country-list .country .dial-code {\n    font-size: 12px !important;\n    min-width: 40px !important;\n    padding: 3px 6px !important;\n  }\n\n  .react-tel-input .country-list .country .flag {\n    width: 18px !important;\n    height: 14px !important;\n  }\n\n  /* Mobile Search Box */\n  .react-tel-input .search-box {\n    margin: 12px !important;\n    width: calc(100% - 24px) !important;\n    font-size: 14px !important;\n    padding: 10px 14px !important;\n    height: 40px !important;\n    border-radius: 10px !important;\n  }\n\n  /* Mobile Checkbox Container */\n  .checkboxContainer {\n    margin: 14px 0;\n    gap: 10px;\n  }\n\n  .checkboxContainer input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    min-width: 18px;\n    min-height: 18px;\n  }\n\n  .checkboxLabel {\n    font-size: 13px;\n    line-height: 1.4;\n  }\n\n  /* Mobile Button */\n  .btnContainer {\n    height: 52px !important;\n    font-size: 15px !important;\n  }\n\n  .btnText {\n    font-size: 15px !important;\n  }\n}\n\n/* Extra Small Mobile Devices */\n@media (max-width: 480px) {\n  .CreateNewAccount {\n    padding: 0 15px;\n  }\n\n  .createNewAccountContainer {\n    gap: 16px;\n    padding: 15px 0;\n  }\n\n  .getStartedText {\n    font-size: 22px !important;\n  }\n\n  .signInText2 {\n    font-size: 14px !important;\n  }\n\n  .labelText {\n    font-size: 15px !important;\n  }\n\n  /* Extra Small Phone Input */\n  .react-tel-input .form-control {\n    height: 52px !important;\n    font-size: 15px !important;\n    padding: 14px 16px 14px 84px !important;\n    border-radius: 12px !important;\n  }\n\n  /* Extra Small Country Selection */\n  .react-tel-input .selected-flag {\n    width: 76px !important;\n    min-width: 76px !important;\n    max-width: 76px !important;\n    height: 52px !important;\n    padding: 0 8px !important;\n    border-radius: 12px 0 0 12px !important;\n  }\n\n  .react-tel-input .selected-flag .selected-dial-code {\n    font-size: 12px !important;\n  }\n\n  .react-tel-input .selected-flag .flag {\n    width: 16px !important;\n    height: 12px !important;\n  }\n\n  /* Extra Small Dropdown */\n  .react-tel-input .country-list {\n    max-height: 30vh !important;\n    margin-top: 4px !important;\n    border-radius: 12px !important;\n  }\n\n  .react-tel-input .country-list .country {\n    padding: 12px 14px !important;\n    font-size: 13px !important;\n    min-height: 48px !important;\n  }\n\n  .react-tel-input .country-list .country .country-name {\n    font-size: 13px !important;\n  }\n\n  .react-tel-input .country-list .country .dial-code {\n    font-size: 11px !important;\n    min-width: 36px !important;\n    padding: 2px 5px !important;\n  }\n\n  .react-tel-input .country-list .country .flag {\n    width: 16px !important;\n    height: 12px !important;\n  }\n\n  /* Extra Small Search Box */\n  .react-tel-input .search-box {\n    margin: 10px !important;\n    width: calc(100% - 20px) !important;\n    font-size: 13px !important;\n    padding: 8px 12px !important;\n    height: 36px !important;\n    border-radius: 8px !important;\n  }\n\n  /* Extra Small Checkbox Container */\n  .checkboxContainer {\n    margin: 12px 0;\n    gap: 8px;\n  }\n\n  .checkboxContainer input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    min-width: 16px;\n    min-height: 16px;\n  }\n\n  .checkboxLabel {\n    font-size: 12px;\n    line-height: 1.3;\n  }\n\n  /* Extra Small Button */\n  .btnContainer {\n    height: 48px !important;\n    font-size: 14px !important;\n  }\n\n  .btnText {\n    font-size: 14px !important;\n  }\n}\n\n/* Very Small Screens (360px and below) */\n@media (max-width: 360px) {\n  .CreateNewAccount {\n    padding: 0 12px;\n  }\n\n  .createNewAccountContainer {\n    gap: 14px;\n    padding: 12px 0;\n  }\n\n  /* Very Small Phone Input */\n  .react-tel-input .form-control {\n    height: 48px !important;\n    font-size: 14px !important;\n    padding: 12px 14px 12px 80px !important;\n    border-radius: 10px !important;\n  }\n\n  /* Very Small Country Selection */\n  .react-tel-input .selected-flag {\n    width: 72px !important;\n    min-width: 72px !important;\n    max-width: 72px !important;\n    height: 48px !important;\n    padding: 0 6px !important;\n    border-radius: 10px 0 0 10px !important;\n  }\n\n  .react-tel-input .selected-flag .selected-dial-code {\n    font-size: 11px !important;\n  }\n\n  .react-tel-input .selected-flag .flag {\n    width: 14px !important;\n    height: 10px !important;\n  }\n\n  /* Very Small Dropdown */\n  .react-tel-input .country-list {\n    max-height: 25vh !important;\n    border-radius: 10px !important;\n  }\n\n  .react-tel-input .country-list .country {\n    padding: 10px 12px !important;\n    font-size: 12px !important;\n    min-height: 44px !important;\n  }\n\n  .react-tel-input .country-list .country .country-name {\n    font-size: 12px !important;\n  }\n\n  .react-tel-input .country-list .country .dial-code {\n    font-size: 10px !important;\n    min-width: 32px !important;\n    padding: 2px 4px !important;\n  }\n\n  .react-tel-input .country-list .country .flag {\n    width: 14px !important;\n    height: 10px !important;\n  }\n\n  /* Very Small Search Box */\n  .react-tel-input .search-box {\n    margin: 8px !important;\n    width: calc(100% - 16px) !important;\n    font-size: 12px !important;\n    padding: 6px 10px !important;\n    height: 32px !important;\n    border-radius: 6px !important;\n  }\n\n  /* Very Small Checkbox Container */\n  .checkboxContainer {\n    margin: 10px 0;\n    gap: 6px;\n  }\n\n  .checkboxContainer input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    min-width: 14px;\n    min-height: 14px;\n  }\n\n  .checkboxLabel {\n    font-size: 11px;\n    line-height: 1.2;\n  }\n\n  /* Very Small Button */\n  .btnContainer {\n    height: 44px !important;\n    font-size: 13px !important;\n  }\n\n  .btnText {\n    font-size: 13px !important;\n  }\n}\n\n/* Snackbar Styles */\n.snackbar {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  z-index: 1000;\n  animation: slideUp 0.3s ease-out;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 250px;\n  text-align: center;\n}\n\n.snackbar-success {\n  background-color: #4caf50;\n}\n\n.snackbar-error {\n  background-color: #f44336;\n}\n\n.snackbar-info {\n  background-color: #48d1cc;\n}\n\n.snackbar-message {\n  display: block;\n  line-height: 1.4;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* Responsive adjustments for snackbar */\n@media (max-width: 1024px) {\n  .snackbar {\n    font-size: 13px;\n    padding: 10px 20px;\n    min-width: 220px;\n  }\n}\n\n@media (max-width: 768px) {\n  .snackbar {\n    font-size: 12px;\n    padding: 8px 16px;\n    min-width: 200px;\n    bottom: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
